import lodash from "lodash";
import { createDeleteButton } from "./../_shared/plugin-toolbar/create-delete-button.js";
import { createLinkButton } from "./../_shared/plugin-toolbar/create-link-button.js";
import { createNodeAlignmentButton } from "./../_shared/plugin-toolbar/create-node-alignment-button.js";
import { createSettingsButton } from "./../_shared/plugin-toolbar/create-settings-button.js";
import { createSeparator } from "./../_shared/plugin-toolbar/separator/create-separator.js";
import { buttonsModals } from "./constants.js";
import { ButtonSettingsModal } from "./modals/SettingsModal.js";
const getToolbarButtons = ({
  config,
  services,
  type
}) => {
  const alignmentModalId = buttonsModals.alignment[type];
  const settingsModalId = buttonsModals.settings[type];
  return [
    createNodeAlignmentButton({ services, modalId: alignmentModalId }),
    createLinkButton(services),
    createSettingsButton({
      modalId: settingsModalId,
      command: ({ modals, referenceElement, attributes }) => {
        modals.togglePluginPanel({
          id: settingsModalId,
          isMobile: services.context.isMobile,
          Component: ButtonSettingsModal,
          componentProps: {
            nodeId: attributes.selectedNode?.attrs.id,
            settings: config,
            type,
            modalId: settingsModalId,
            referenceElement
          },
          positioning: {
            referenceElement: referenceElement?.closest("[data-hook~=floating-plugin-toolbar]") ?? referenceElement,
            placement: "right-start"
          },
          onClickOutside: {
            on: "pointerup",
            handler: lodash.noop
          },
          focusReturnElement: referenceElement
        });
      }
    }),
    createSeparator(),
    createDeleteButton()
  ];
};
export {
  getToolbarButtons
};
//# sourceMappingURL=getToolbarButtons.js.map
